// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"125472068e23a37a6a79","263":"cafa65725fe743e4e79f","264":"0f905677d0ee92b25e72","317":"c77d0141086eb8cd7e27"}[chunkId] + ".chunk.js";
};